import React from 'react';
import './App.css';
import SortingVisualizer from './SortingVisualizer/SortingVisualizer'
function App() {
  return (
    <div className="App">
      <h1>Merge Sort Visualizer</h1>
      <SortingVisualizer></SortingVisualizer>
    </div>
  );
}

export default App;
